import { createSelector } from 'reselect'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'

export const getIsMerchandiseEnabled = createSelector(
  (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.merchandiseLaunch),
  (merchandiseLaunchEnabled) => {
    return !!merchandiseLaunchEnabled
  },
)
